export default __webpack_public_path__ + "static/media/billy_coin.69d40e7e.png";